import { createContext, useState, useEffect, useContext } from "react";

const EnquiryToastContext = createContext();

export const EnquiryToastProvider = ({ children }) => {
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    let interval;
    if (showToast) {
      interval = setTimeout(() => setShowToast(false), 5000);
    }

    return () => {
      clearTimeout(interval);
    };
  }, [showToast]);
  return (
    <EnquiryToastContext.Provider
      value={{ showToast: showToast, setShowToast: setShowToast }}
    >
      {children}
    </EnquiryToastContext.Provider>
  );
};

export const useEnquiryToast = () => useContext(EnquiryToastContext);
